<template>
  <div >
    <section class="main no-flex">
      <ArticleNameTrackingTable />
    </section>
  </div>
</template>

<script>
import ArticleNameTrackingTable from '../components/ArticleNameTrackingTable.vue'

export default {
  name: 'Home',
  components: {
    ArticleNameTrackingTable,
  },
}
</script>
<style scoped lang="scss">
@media screen and (max-width: 1190px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}
</style>
